import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input';
import Select from '../form/selects/Select';
import Checkbox from '../form/checkbox/Checkbox';
import revenuesScore from './../../static-data/revenue-score.json'
import months from './../../static-data/months.json'
import moment from 'moment';
import Text from '../text/Text';

const Revenues = ( props ) => {
    const dispatch                  = useDispatch()

    let prevYearRevenuesTwo         = useSelector(state => state.prevYearRevenuesTwo)
    let revenueOldTwo               = useSelector(state => state.revenueOldTwo)
    let revenueProfitOldTwo         = useSelector(state => state.revenueProfitOldTwo)
    let revenueScoreOldTwo          = useSelector(state => state.revenueScoreOldTwo)
    let revenueLossExplanationOldTwo = useSelector(state => state.revenueLossExplanationOldTwo)
    
    let prevYearRevenues            = useSelector(state => state.prevYearRevenues)
    let revenueOld                  = useSelector(state => state.revenueOld)
    let revenueProfitOld            = useSelector(state => state.revenueProfitOld)
    let revenueScoreOld             = useSelector(state => state.revenueScoreOld)
    let revenueLossExplanationOld   = useSelector(state => state.revenueLossExplanationOld)

    let revenue                     = useSelector(state => state.revenue)
    let revenueFrom                 = useSelector(state => state.revenueFrom)
    let revenueTo                   = useSelector(state => state.revenueTo)
    let revenueScore                = useSelector(state => state.revenueScore)
    let revenueProfit               = useSelector(state => state.revenueProfit)
    let revenueLossExplanation      = useSelector(state => state.revenueLossExplanation)
    let maxThreshold                = useSelector(state => state.maxThreshold);
    let productPrice                = useSelector(state => state.productPrice); 

    let getFirstYear = () => {
        let getMonth = moment().month();
        let getActualYear = moment().add(-1, 'years').year();

        if ( getMonth < 1 ) {
            getActualYear = moment().add(-2, 'years').year();
        }
        return getActualYear;
    }

    let getYear = count => {
        let getMonth = moment().month();
        let getActualYear = moment().year();

        if ( getMonth < 1 ) {
            getActualYear = moment().add(count, 'years').year();
        }
        return getActualYear;
    }

    let getYearTwo = count => {
        let getMonth = moment().month();
        let getActualYear = moment().year();
        getActualYear = moment().subtract(2, 'years').year();

        return getActualYear;
    }

    let getLastMonth = () => {
        return moment().add(-1, 'months').month();
    }

    return (
        <div className="revenues">
            <Heading title="Dane finansowe" medium smallMargin />
            { productPrice > maxThreshold &&
            
            <div className="row nomargin">
                <Heading title={ "Dane za rok " + getYearTwo() } small />

                {/* <Checkbox  required={ false } 
                           setFunction={ (val) =>  dispatch({ type: 'PREV_YEAR_REVENUES_TWO_CHANGE', value: val })}
                           forceValidate={ props.forceValidate }
                           val={ prevYearRevenuesTwo }
                           text="Nie dotyczy" /> */}
                
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "revenue-old" }
                                id="revenue-old"
                                required={ prevYearRevenuesTwo ? false : true }
                                setFunction={ val =>  dispatch({ type: 'REVENUE_OLD_TWO_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Przychód w zł" }
                                val={ revenueOldTwo }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } 
                                disabledForce={ (prevYearRevenuesTwo ? true : false )} />

                    </div>
                    <div className="col">
                        <Select
                            id="revenues-score"
                            data={ revenuesScore }  
                            forceValidate={ props.forceValidate } 
                            placehold="Wynik netto w zł" 
                            val={ revenueScoreOldTwo }
                            required={ prevYearRevenuesTwo ? false : true }
                            setFunction={ val => dispatch({ type: 'REVENUE_SCORE_OLD_TWO_CHANGE', value: val }) }  
                            disabledForce={ (prevYearRevenuesTwo ? true : false )} />
                    </div>
                    <div className="col">
                        <Input  name={ "revenue-profit-old" }
                                id="revenue-profit-old"
                                required={ prevYearRevenuesTwo ? false : true}
                                setFunction={ val =>  dispatch({ type: 'REVENUE_PROFIT_OLD_TWO_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kwota zysku / straty w zł" }
                                val={ revenueProfitOldTwo }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } 
                                disabledForce={ (prevYearRevenuesTwo ? true : false )} />
                    </div>
                </div>
                <div className="inputs">
                    {revenueScoreOldTwo == "Strata" &&
                        <Input  name={ "revenue-loss-explanation-old-two" }
                            id="revenue-loss-explanation-old-two"
                            required={ prevYearRevenuesTwo ? false : true}
                            setFunction={ val =>  dispatch({ type: 'REVENUE_LOSS_EXPLANATION_OLD_TWO_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Wyjaśnienie straty" }
                            val={ revenueLossExplanationOldTwo }
                            size="full" 
                            minChar={ 1 } 
                            forceValidate={ props.forceValidate } 
                            disabledForce={ (prevYearRevenuesTwo ? true : false )} />
                    }
                </div>
            </div>
            }

            <div className={"row" + ( productPrice <= maxThreshold ? ' nomargin' : '')}>
                <Heading title={ "Dane za rok " + getFirstYear()} small />

                {/* <Checkbox  required={ false } 
                           setFunction={ (val) =>  dispatch({ type: 'PREV_YEAR_REVENUES_CHANGE', value: val })}
                           forceValidate={ props.forceValidate }
                           val={ prevYearRevenues }
                           text="Nie dotyczy" /> */}
                
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "revenue-old" }
                                id="revenue-old"
                                required={ prevYearRevenues ? false : true }
                                setFunction={ val =>  dispatch({ type: 'REVENUE_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Przychód w zł" }
                                val={ revenueOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } 
                                disabledForce={ (prevYearRevenues ? true : false )} />

                    </div>
                    <div className="col">
                        <Select
                            id="revenues-score"
                            data={ revenuesScore }  
                            forceValidate={ props.forceValidate } 
                            placehold="Wynik netto w zł" 
                            val={ revenueScoreOld }
                            required={ prevYearRevenues ? false : true }
                            setFunction={ val => dispatch({ type: 'REVENUE_SCORE_OLD_CHANGE', value: val }) }  
                            disabledForce={ (prevYearRevenues ? true : false )} />
                    </div>
                    <div className="col">
                        <Input  name={ "revenue-profit-old" }
                                id="revenue-profit-old"
                                required={ prevYearRevenues ? false : true}
                                setFunction={ val =>  dispatch({ type: 'REVENUE_PROFIT_OLD_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kwota zysku / straty w zł" }
                                val={ revenueProfitOld }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate } 
                                disabledForce={ (prevYearRevenues ? true : false )} />
                    </div>
                </div>
                <div className="inputs">
                    {revenueScoreOld == "Strata" &&
                        <Input  name={ "revenue-loss-explanation-old" }
                            id="revenue-loss-explanation-old"
                            required={ prevYearRevenues ? false : true}
                            setFunction={ val =>  dispatch({ type: 'REVENUE_LOSS_EXPLANATION_OLD_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Wyjaśnienie straty" }
                            val={ revenueLossExplanationOld }
                            size="full" 
                            minChar={ 1 } 
                            forceValidate={ props.forceValidate } 
                            disabledForce={ (prevYearRevenues ? true : false )} />
                    }
                </div>
            </div>

            <div className="row">
                <Heading title={ "Dane za rok " + getYear(-1) } small />
                <div className="inputs">
                    <div className="col">
                        <Select
                            id="from"
                            data={ months }  
                            forceValidate={ props.forceValidate } 
                            placehold="Od" 
                            required={ true }
                            disabledIndex={ getLastMonth() }
                            val={ revenueFrom }
                            setFunction={ val => dispatch({ type: 'REVENUE_FROM_CHANGE', value: val }) }  />
                    </div>
                    <div className="col">
                        <Select
                            id="to"
                            data={ months }  
                            forceValidate={ props.forceValidate } 
                            placehold="Do" 
                            required={ true }
                            val={ revenueTo }
                            disabledIndex={ getLastMonth() }
                            setFunction={ val => dispatch({ type: 'REVENUE_TO_CHANGE', value: val }) }   />
                    </div>
                </div>
                <div className="inputs">
                    <div className="col">
                        <Input  name={ "revenue" }
                                id="revenue"
                                required={ true }
                                setFunction={ val =>  dispatch({ type: 'REVENUE_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Przychód w zł" }
                                val={ revenue }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate }  />
                    </div>
                    <div className="col">
                        <Select
                            id="netto-result"
                            data={ revenuesScore }  
                            required={ true }
                            forceValidate={ props.forceValidate } 
                            placehold="Wynik netto w zł" 
                            val={ revenueScore }
                            setFunction={ val => dispatch({ type: 'REVENUE_SCORE_CHANGE', value: val }) }   />
                    </div>
                    <div className="col">
                        <Input  name={ "revenue-profit" }
                                id="revenue-profit"
                                required={ true }
                                setFunction={ val =>  dispatch({ type: 'REVENUE_PROFIT_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Kwota zysku / straty w zł" }
                                val={ revenueProfit }
                                size="xxl" 
                                formatPrice={ true }
                                regExp={/^[0-9\,\.\s]+$/}
                                allowChars={/^[0-9\,\.\s]+$/}
                                minChar={ 0 } 
                                forceValidate={ props.forceValidate }  />
                    </div>
                </div>
                <div className="inputs">
                    {revenueScore == "Strata" &&
                        <Input  name={ "revenue-loss-explanation" }
                            id="revenue-loss-explanation"
                            required={ true }
                            setFunction={ val =>  dispatch({ type: 'REVENUE_LOSS_EXPLANATION_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Wyjaśnienie straty" }
                            val={ revenueLossExplanation }
                            size="full" 
                            minChar={ 1 } 
                            forceValidate={ props.forceValidate } />
                    }
                </div>
            </div>
            
        </div>
    )
}

export default Revenues;